export type AppIdentity = {
  application_id: string;
  spn_name: string;
};

export const initialFormValues = (tier: string) => {
  return {
    environment: [],
    application_name: '',
    model_name: [],
    model_id: [],
    primary_owner: '',
    wl3_approver: '',
    application_description: '',
    secondary_owner: '',
    icc: '',
    cc: '',
    aif_rag_access: false,
    ai_inventory_id: '',
    onboardingstatus: null,
    spn_appid_env_map: [],
    adgroupforappaccess: [],
    tier: tier
  };
};

export const errorMessages = {
  serverError: 'Something Went wrong',
  emptyValue: 'No data Found',
  aceesIssue: 'You are not allowed to access the model'
};

export const RAGLink = {
  dev: 'https://aifragdev.unilever.com',
  uat: 'https://aifraguat.unilever.com',
  prod: 'https://aifragprod.unilever.com'
};
export const envVariables = {
  local: {
    // apiBaseUrl: 'http://127.0.0.1:5000',
    // hostname: 'http://localhost:3000',
    apiBaseUrl: 'https://bnlwe-ai04-d-930633-webapi-03.azurewebsites.net',
    hostname: 'bnlwe-ai04-d-930633-webapi-02.azurewebsites.net',
    clientId: '1c8be9a0-b452-44f9-87c8-2e324a221e94',
    scopesToConsent: 'api://8c38a317-025f-4aaf-81a4-1596627f4941/access'
  },
  dev: {
    apiBaseUrl: 'https://bnlwe-ai04-d-930633-webapi-03.azurewebsites.net',
    hostname: 'bnlwe-ai04-d-930633-webapi-02.azurewebsites.net',
    // apiBaseUrl: 'http://127.0.0.1:5000',
    // hostname: 'http://localhost:3000',
    clientId: '1c8be9a0-b452-44f9-87c8-2e324a221e94',
    scopesToConsent: 'api://8c38a317-025f-4aaf-81a4-1596627f4941/access'
  },
  qa: {
    apiBaseUrl: 'https://bnlwe-ai03-q-931039-webapi-03.azurewebsites.net',
    hostname: 'bnlwe-ai03-q-931039-webapi-02.azurewebsites.net',
    clientId: '9d2662be-6d93-4c89-8fa0-38b48896aa9a',
    scopesToConsent: 'api://2ae81fb9-36f9-48a8-9e44-a3c213588aa5/access'
  },
  prod: {
    apiBaseUrl: 'https://bnlwe-ai01-p-930632-webapi-03.azurewebsites.net',
    hostname: 'bnlwe-ai01-p-930632-webapi-02.azurewebsites.net',
    clientId: '2c14aa0a-7463-4a27-8e4f-359646cb0e1d',
    scopesToConsent: 'api://434c1d1b-608e-4c80-8551-922381799d6e/access'
  }
};
export const pages = [
  { id: 1, name: 'Dashboard', path: '/dashboard', groupname: 'dashboard' },
  { id: 2, name: 'Responsible AI', path: '/rai', groupname: 'model' },
  { id: 3, name: 'Leaderboard', path: '/leaderboard', groupname: 'model' },
  { id: 4, name: 'Prompt Library', path: '/promptlibrary', groupname: 'prompt' },
  { id: 5, name: 'Prompt Playground', path: '/promptplayground', groupname: 'prompt' },
  { id: 6, name: 'FinOps', path: '/finops', groupname: 'finops' }
];

export const unileverColor = {
  green: {
    rgb: 'rgba(97, 212, 196, 1)',
    hex: '#61D4C4'
  },
  pink: {
    rgb: 'rgba(255, 121, 198, 1)',
    hex: '#FF79C6'
  },
  blue: {
    rgb: 'rgba(143, 202, 235, 1)',
    hex: '#8FCAEB'
  },
  purple: {
    rgb: 'rgba(119, 5, 188, 1)',
    hex: '#7705BC'
  },
  violet: {
    rgb: 'rgba(132, 108, 226, 1)',
    hex: '#846CE2'
  },
  plum: {
    rgb: 'rgba(199, 154, 213, 1)',
    hex: '#C79AD5'
  },
  rose: {
    rgb: 'rgba(239, 88, 145, 1)',
    hex: '#EF5891'
  },
  orange: {
    rgb: 'rgba(241, 163, 58, 1)',
    hex: '#F1A33A'
  },
  yellow: { rgb: 'rgba(255, 227, 0, 1)', hex: '#FFE300' },
  cream: {
    rgb: 'rgba(252, 237, 164, 1)',
    hex: '#FCEDA4'
  },
  grey: {
    rgb: 'rgba(199, 199, 199, 1)',
    hex: '#C7C7C7'
  },
  red: {
    rgb: 'rgba(236, 97, 87, 1)',
    hex: '#EC6157'
  },
  amber: {
    rgb: 'rgba(255, 221, 55, 1)',
    hex: '#FFDD37'
  }
  // updated Colors
  // blue_n: { rgb: 'rgba(0, 102, 204, 1)', hex: '#0066CC' },
  // grey_tone: { rgb: 'rgba(131, 143, 180, 1)', hex: '#838FB4' },
  // text_darkGrey: { rgb: 'rgba(77, 77, 77, 1)', hex: '#4D4D4D' }
};
